export enum Source {
    GOOGLE = 'google',
    BOKADIREKT = 'bokadirekt',
    TRUSTPILOT = 'trustpilot',
    RECO = 'reco',
}
